import React, { forwardRef } from 'react';
import UploadZone from './UploadZone';
import GoogleDriveBrowser from './GoogleDriveBrowser';

const UploadsPanel = forwardRef(function UploadsPanel({
  siteId,
  onUploaded,
  showUploadControls = true,
  targetFolder = '',
  accept = '',
}, ref) {
  return (
    <div className="flex flex-col gap-4">
      <GoogleDriveBrowser siteId={siteId} />
      <UploadZone
        ref={ref}
        siteId={siteId}
        onUploaded={onUploaded}
        showControls={showUploadControls}
        targetFolder={targetFolder}
        accept={accept}
      />
    </div>
  );
});

export default UploadsPanel;
